/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import LoginComponent from "./site-login";
import { isUserLoggedIn } from "state/current-user/selectors";
import { EurekaCallbackPage } from "./eureka-callback";

export const login = (context, next) => {
  const userLoggedIn = isUserLoggedIn(context.store.getState());

  if (userLoggedIn) {
    window.location = "/";
    return;
  }

  context.primary = <LoginComponent />;
  next();
};

export const eurekaCallback = (context, next) => {
  context.primary = <EurekaCallbackPage />;
  next();
};
